// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7cfeb2ec","481":"bb99ca95"}[chunkId] + ".chunk.js";
};